module.exports = __webpack_public_path__ + "static/media/institution-number.3a86c88f.png";